<template lang="pug">
div
  interessado-sicarf(
    :interessado="cadastro.interessado",
    :cadastrante="cadastro.cadastrante",
    :observer="observer",
    :hasSocios="true"
    :hasEspolio="true"
    :isProcessoFisico="true"
  )
  app-documentos(
    :maxSize='25',
    :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
    :documentos="cadastro.interessado.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorios"
    :observer="observer",
    aba="Interessado",
    :validateRule='"documentosObrigatorios"'
  )
</template>

<script>
import InteressadoSicarf from '../../../../components/cadastro/InteressadoSicarf'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'
import { mapActions } from 'vuex'

export default {
  props: ['cadastro', 'observer'],

  components: {
    InteressadoSicarf,
    AppDocumentos
  },
  data () {
    return {
      documentos: [],
      documentosGeral: [],
      documentosObrigatorios: []
    }
  },
  async created () {
    const documentosTod = await this.findDocumentos('interessadoPfProcessoFisico')
    this.documentosGeral = documentosTod
    this.documentos = documentosTod.filter(documento => ['DOCUMENTO_DE_IDENTIFICACAO_PESSOAL_INTERESSADO', 'OUTROS_INTERESSADO', 'PROCESSO_INTEGRAL'].includes(documento.tipo))
  },
  computed: {
    interessado () {
      return this.cadastro.interessado
    }
  },
  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    })
  },
  watch: {
    'interessado.pessoa.tipo': {
      async handler (val) {
        if (val === 'PJ') {
          this.documentos = await this.findDocumentos('interessadoPjProcessoFisico')
          this.documentosGeral = this.documentos
        } else {
          this.documentos = await this.findDocumentos('interessadoPfProcessoFisico')
          this.documentosGeral = this.documentos
        }
        this.observer.reset()
      }
    },
    'interessado.pessoa.pessoaFisica.estadoCivil': {
      async handler (val) {
        if (val === 'CASADO' || val === 'UNIAO_ESTAVEL') {
          this.documentos = this.documentosGeral
        } else {
          this.documentos = this.documentosGeral.filter(documento => ['DOCUMENTO_DE_IDENTIFICACAO_PESSOAL_INTERESSADO', 'OUTROS_INTERESSADO', 'PROCESSO_INTEGRAL'].includes(documento.tipo))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/components/Interessado.vue